import { render, staticRenderFns } from "./LessonCompleted.vue?vue&type=template&id=a7add0f2&scoped=true&"
import script from "./LessonCompleted.vue?vue&type=script&lang=js&"
export * from "./LessonCompleted.vue?vue&type=script&lang=js&"
import style0 from "./LessonCompleted.vue?vue&type=style&index=0&id=a7add0f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7add0f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
